import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './styles';

const SidepanelLayout = ({ sidepanel, content }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.sidepanel}>{sidepanel}</div>

			<div className={classes.content}>{content}</div>
		</div>
	);
};

SidepanelLayout.propTypes = {
	sidepanel: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	content: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default SidepanelLayout;
